import { useMemo } from "react"
import {
  filterPatientsBySegment,
  buildPatientModuleMetrics
} from "../utils/patientFilters"
import { getPatientInitials } from "../utils/patientFormatting"

export default function usePatientsViewModel({
  patients,
  activeFilter,
  patientSummary,
  selectedPatient
}) {
  const filteredPatients = useMemo(() => {
    return filterPatientsBySegment(patients, activeFilter)
  }, [patients, activeFilter])

  const moduleMetrics = useMemo(() => {
    return buildPatientModuleMetrics(patients)
  }, [patients])

  const patientName = useMemo(() => {
    if (patientSummary?.patient) {
      return `${patientSummary.patient.firstName || ""} ${patientSummary.patient.lastName || ""}`.trim()
    }

    if (selectedPatient) {
      return `${selectedPatient.firstName || ""} ${selectedPatient.lastName || ""}`.trim()
    }

    return ""
  }, [patientSummary, selectedPatient])

  const phone =
    patientSummary?.patient?.phone || selectedPatient?.phone || ""

  const email =
    patientSummary?.patient?.email || selectedPatient?.email || ""

  const summaryPending = patientSummary?.summary?.pendingReceivables || 0
  const recentAppointmentsCount = patientSummary?.summary?.recentAppointmentsCount || 0
  const upcomingAppointmentsCount = patientSummary?.summary?.upcomingAppointmentsCount || 0
  const recentTreatmentsCount = patientSummary?.summary?.recentTreatmentsCount || 0

  const lastVisit =
    patientSummary?.recentAppointments?.[0]?.startTime || null

  const nextVisit =
    patientSummary?.upcomingAppointments?.[0]?.startTime || null

  const patientStatusTag = summaryPending > 0
    ? { label: "Con saldo pendiente", bg: "#fef2f2", color: "#991b1b", border: "#fecaca" }
    : upcomingAppointmentsCount > 0
      ? { label: "Seguimiento activo", bg: "#ecfeff", color: "#0f766e", border: "#a5f3fc" }
      : { label: "Paciente controlado", bg: "#f0fdf4", color: "#166534", border: "#bbf7d0" }

  const patientInitials = getPatientInitials(patientName || "Paciente")

  return {
    filteredPatients,
    moduleMetrics,
    patientName,
    phone,
    email,
    summaryPending,
    recentAppointmentsCount,
    upcomingAppointmentsCount,
    recentTreatmentsCount,
    lastVisit,
    nextVisit,
    patientStatusTag,
    patientInitials
  }
}